import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import * as PropTypes from 'prop-types';
import { isFunction, isArray } from '@utiljs/is';

var Accordion = /*#__PURE__*/function (_React$Component) {
  _inherits(Accordion, _React$Component);

  var _super = _createSuper(Accordion);

  function Accordion(props) {
    var _this;

    _classCallCheck(this, Accordion);

    _this = _super.call(this, props);

    _this.handlePanelClick = function (key) {
      var activeKey = _this.state.activeKey;
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          multiple = _this$props.multiple,
          activeKeyProps = _this$props.activeKey;

      if (activeKey.includes(key)) {
        activeKey.splice(activeKey.indexOf(key), 1);
      } else if (multiple) {
        activeKey.push(key);
      } else {
        activeKey.splice(0, 1, key);
      }

      if (activeKeyProps === undefined) {
        _this.setState({
          activeKey: activeKey
        }, function () {
          if (isFunction(onChange)) {
            onChange(activeKey, key);
          }
        });
      } else if (isFunction(onChange)) {
        onChange(activeKey, key);
      }
    };

    _this.getChildItem = function (child, index) {
      var _child$props = child.props,
          title = _child$props.title,
          disabled = _child$props.disabled,
          className = _child$props.className,
          style = _child$props.style,
          childHasArrow = _child$props.hasArrow,
          childArrowPosition = _child$props.arrowPosition;
      var key = child.key || index;
      var activeKey = _this.state.activeKey;
      var _this$props2 = _this.props,
          hasArrow = _this$props2.hasArrow,
          arrowPosition = _this$props2.arrowPosition;
      if ('hasArrow' in child.props) hasArrow = childHasArrow;
      if ('arrowPosition' in child.props) arrowPosition = childArrowPosition;
      var props = {
        key: key,
        panelKey: key,
        className: className,
        style: style,
        title: title,
        disabled: disabled,
        hasArrow: hasArrow,
        arrowPosition: arrowPosition,
        isActive: activeKey.includes(key),
        onPanelClick: _this.handlePanelClick
      };
      return /*#__PURE__*/React.cloneElement(child, props);
    };

    var activeKey = props.activeKey,
        defaultActiveKey = props.defaultActiveKey,
        multiple = props.multiple;
    var validActiveKey = defaultActiveKey;

    if (activeKey !== undefined) {
      validActiveKey = activeKey;
    }

    if (!isArray(validActiveKey)) {
      validActiveKey = validActiveKey ? [validActiveKey] : [];
    }

    if (!multiple && validActiveKey.length) {
      validActiveKey = [validActiveKey[0]];
    }

    _this.state = {
      activeKey: validActiveKey.map(function (key) {
        return String(key);
      })
    };
    return _this;
  }

  _createClass(Accordion, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          className = _this$props3.className,
          style = _this$props3.style;
      var newChildren = React.Children.map(children, this.getChildItem);
      return /*#__PURE__*/React.createElement("div", {
        className: "roo-accordion ".concat(className),
        style: style
      }, newChildren);
    }
  }]);

  return Accordion;
}(React.Component);

Accordion.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  multiple: PropTypes.bool,
  hasArrow: PropTypes.bool,
  arrowPosition: PropTypes.oneOf(['left', 'right']),
  onChange: PropTypes.func
};
Accordion.defaultProps = {
  className: '',
  style: {},
  multiple: true,
  hasArrow: true,
  arrowPosition: 'left',
  onChange: function onChange() {}
};
export default Accordion;